require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./contact.json") })
        }
      }, "path---contact");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---contact!./.cache/json/contact.json
// module id = 763
// module chunks = 231608221292675